import { Box, Card, CardContent, Typography, Grid } from '@mui/material';

const ServiceCards = () => {
  const cardData = [
    { id: 1, title: 'Research and Development', icon: 'rnd1.webp' },
    { id: 2, title: 'Academic Training and Assistance', icon: '9490629.webp' },
    { id: 3, title: 'Publication and Support', icon: 'ps.webp' },
    { id: 4, title: 'Writing and Implementation', icon: '3369768.webp' },
  ];

  return (
    <Grid container spacing={2} sx={{ position: 'relative', justifyContent: 'center' }}>
      {cardData.map((card) => (
        <Grid item xs={5} key={card.id}>
          <Card sx={{ borderRadius: '16px', background: '#012e57' }}>
            <CardContent  sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className='component'>
              {/* Use img tag to render the icon as an image */}
              <Box
                component="img"
                src={card.icon}
                alt={card.title}
                sx={{ width: { xs: '40px', sm: '50px', md: '60px' }, height: { xs: '40px', sm: '50px', md: '60px' }, marginBottom: '10px'}}
              />
              <Typography variant="h6" color={"white"} sx={{ fontSize: { xs: '14px', sm: '16px', md: '18px' }, textAlign: 'center' }}>{card.title}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          borderRadius: '50%',
          width: { xs: '120px', sm: '140px',  },
          height: { xs: '120px', sm: '140px', },
          backgroundColor: '#fff',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0px 0px 15px rgba(0,0,0,0.1)',
        }}
      >
        <Typography variant="h6" color={"#012e57"} sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' } }} className='component'>10 years experience</Typography>
      </Box>
    </Grid>
  );
};

export default ServiceCards;
